import "./ClientNotesContentComponent.scss";
import template from "./ClientNotesContentComponent.html";
import {IComponentOptions} from "angular";
import {ComponentCallback} from "../../../../types/AngularJS";
import {BehaviorSubject} from "rxjs";

export const ClientNotesContent = "tfClientNotesContent";

export function clientNotesContent(): IComponentOptions {
    return {
        template,
        bindings: {
            noteTag: "<",
            content: "<",
            editing: "<",
            onClose: "&",
            onChange: "&"
        },
        controllerAs: "ctrl",
        controller: ClientNotesContentComponentController
    };
}

export class ClientNotesContentComponentController {

    /** @input */
    public readonly content: string;

    public readonly noteTag: string;

    /** @input */
    public set editing(editing: boolean) {
        if (editing) {
            this.contentCopy = this.content;
            this.noteTagCopy = this.noteTag;
        }
        this.editing$.next(editing);
    }

    public readonly editing$ = new BehaviorSubject(false);

    /** @output */
    public readonly onClose: ComponentCallback;

    /** @output */
    public readonly onChange: ComponentCallback;

    public contentCopy: string;

    public noteTagCopy: string;

    public cancel() {
        this.editing = false;
        this.onClose();
    }

    public confirm() {
        this.onChange({content: this.contentCopy, noteTag: this.noteTagCopy});
        this.editing = false;
    }

    public noteTypes: string[] = ['Advice','Order','Portfolio Review','Others'];
}
